export const JOB_CREATED_STATUS = 'created';
export const JOB_COMPLETE_STATUS = 'complete';
export const JOB_PROCESSING_STATUS = 'processing';
export const JOB_FAILED_STATUS = 'failed';
export const JOB_DELETED_STATUS = 'deleted';